// src/app/features/my-team/services/my-teams-store.service.ts
import { computed, Injectable } from '@angular/core';
import { buildApiUrl } from '../../../core/config/api.constants';
import { createEntityStore } from '../../../core/utils/entity-store.util';
import { MyTeam, TeamRole } from '../models/my-team.model';

@Injectable({ providedIn: 'root' })
export class MyTeamsStore {
  // Read-only membership list; the factory's mutations are intentionally not exposed.
  private store = createEntityStore<MyTeam>({
    endpoint: '/api/users/me/teams',
    listUrl: () => buildApiUrl('/api/users/me/teams'),
  });

  readonly teamsResource = this.store.resource;
  readonly teams = this.store.data;
  readonly loading = this.store.loading;
  readonly error = computed(() => (this.store.error() ? 'Failed to load your teams' : null));
  reload = this.store.reload;

  /** Current user's role on a team, or null if not in the loaded membership list. */
  roleFor(teamId: number): TeamRole | null {
    return this.store.byId().get(teamId)?.my_role ?? null;
  }

  teamById(teamId: number): MyTeam | undefined {
    return this.store.byId().get(teamId);
  }
}
